import { Card } from '@sainsburys-tech/luna-card'
import { Body1 } from '@sainsburys-tech/luna-typography'
import { Title } from '../Components'
import { IGuardingActivity } from '../../../types/GuardingActivity/IGuardingActivityType'
import { useState } from 'react'
import GuardingActivityModal from '../../Modal/GuardingActivityModal/GuardingActivityModal'
import getRelativeDate from '../../../utils/getRelativeDate'

const GuardingActivityCard = ({ guardingActivity }: IGuardingActivity) => {
  const [showModal, setShowModal] = useState(false)

  function handleCardClick() {
    setShowModal(true)
  }

  function handleModalClose() {
    setShowModal(false)
  }

  const dateOfActivity= guardingActivity.activityDate ? new Date(`${guardingActivity.activityDate}.000Z`) : null
  const timeOfActivity= new Date(`${guardingActivity.activityDate}.000Z`) ?? null

  const date = getRelativeDate({dateTime:dateOfActivity ?? undefined, type:'date'})
  const time = getRelativeDate({dateTime:timeOfActivity ?? undefined, type:'time24'})

  return (
    <>
      <Card
        className="s-reported-accident-card rln-c-card ln-c-card--soft ln-u-margin-bottom*2 ln-u-margin-left s-card-clickable"
        onClick={handleCardClick}
      >
        <Title text={guardingActivity.guardingActivity } />
        <div>
          <Body1 className="ln-u-color-dark d-block">
            {guardingActivity.activityDate
              ? `Completed: ${date} at ${time}`
              : 'Completion date not set'}
          </Body1>
        </div>
        <div>
          <Body1 className="ln-u-color-dark">
            Reported by: {guardingActivity.addedByName || 'Unknown'}
          </Body1>
        </div>
      </Card>

      <GuardingActivityModal
        open={showModal}
        onClose={handleModalClose}
        guardingActivity={guardingActivity}
      />
    </>
  )
}

export default GuardingActivityCard
